module.exports = __webpack_public_path__ + "static/media/monument.6f6a1c85.svg";